import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { G, FONT_FAMILY, OVERVIEW } from "../../constants/theme";
import ecosenseLogo from "../../assets/ecosense-logo.png";

export const SIDEBAR_WIDTH = 290;

const NAV = [
  { label: "Dashboard", path: "/", icon: "⊞", disabled: false },
  { label: "Lifecycle", path: "/lifecycle", icon: "↻", disabled: false },
  { label: "Workload", path: "/developer-workload", icon: "▤", disabled: false },
  { label: "AI Assistant", path: "/ai-assistant", icon: "✦", disabled: true },
];

const BOTTOM = [
  { label: "Settings", path: "/settings", icon: "⚙", disabled: true },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function NavItem({ label, path, icon, disabled }) {
    const active = !disabled && pathname === path;
    return (
      <div style={{ position: "relative", marginBottom: 2 }}>
        {active && (
          <span
            style={{
              position: "absolute",
              left: -16,
              top: "50%",
              transform: "translateY(-50%)",
              width: 3,
              height: 22,
              borderRadius: "0 3px 3px 0",
              background: G.brand,
            }}
          />
        )}
        <button
          onClick={() => { if (!disabled) navigate(path); }}
          disabled={disabled}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            width: "100%",
            padding: "10px 14px",
            borderRadius: 8,
            border: "none",
            background: active ? "rgba(37,99,235,0.18)" : "transparent",
            boxShadow: active ? "0 1px 3px rgba(37,99,235,0.25)" : "none",
            color: disabled
              ? "rgba(255,255,255,0.22)"
              : active
              ? G.white
              : "rgba(255,255,255,0.55)",
            ...OVERVIEW.support,
            fontWeight: active ? 700 : 500,
            fontFamily: FONT_FAMILY,
            cursor: disabled ? "default" : "pointer",
            textAlign: "left",
            transition: "background 0.12s, color 0.12s",
            opacity: disabled ? 0.5 : 1,
          }}
          onMouseEnter={(e) => {
            if (!active && !disabled) e.currentTarget.style.color = "rgba(255,255,255,0.85)";
          }}
          onMouseLeave={(e) => {
            if (!active && !disabled) e.currentTarget.style.color = "rgba(255,255,255,0.55)";
          }}
        >
          <span
            style={{
              fontSize: 15,
              width: 20,
              textAlign: "center",
              flexShrink: 0,
              color: active ? "#93C5FD" : undefined,
              opacity: disabled ? 0.5 : active ? 1 : 0.65,
            }}
          >
            {icon}
          </span>
          <span style={{ flex: 1 }}>{label}</span>
          {disabled && (
            <span
              style={{
                ...OVERVIEW.eyebrow,
                fontSize: 10,
                color: "rgba(255,255,255,0.25)",
                flexShrink: 0,
              }}
            >
              Soon
            </span>
          )}
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        width: SIDEBAR_WIDTH,
        height: "100vh",
        background: G.dark,
        borderRight: `1px solid ${G.darkBorder}`,
        display: "flex",
        flexDirection: "column",
        zIndex: 90,
        fontFamily: FONT_FAMILY,
      }}
    >
      {/* Branding section — JiraOps is the product identity and leads
          visually; the EcoSense logo is framed as a small "PART OF"
          parent-brand endorsement beneath it, sitting directly on the
          sidebar background (no card, border, or shadow of its own). */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "28px 20px 24px",
          borderBottom: `1px solid ${G.darkBorder}`,
          flexShrink: 0,
        }}
      >
        <span
          style={{
            fontSize: 22,
            fontWeight: 800,
            color: G.white,
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
          }}
        >
          JiraOps
        </span>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 16,
          }}
        >
          <span
            style={{
              ...OVERVIEW.eyebrow,
              fontSize: 10,
              color: "rgba(255,255,255,0.35)",
              flexShrink: 0,
            }}
          >
            Part of
          </span>
          <img
            src={ecosenseLogo}
            alt="EcoSense"
            style={{
              height: 22,
              width: "auto",
              maxWidth: "100%",
              objectFit: "contain",
              display: "block",
            }}
          />
        </div>
      </div>

      {/* Primary nav — pulled down from the logo section so the three
          regions (logo / nav / footer) read as balanced, not top-loaded */}
      <nav style={{ flex: 1, padding: "28px 16px 20px", overflowY: "auto" }}>
        <div
          style={{
            ...OVERVIEW.eyebrow,
            color: "rgba(255,255,255,0.35)",
            paddingLeft: 14,
            marginBottom: 12,
          }}
        >
          Menu
        </div>
        <div>
          {NAV.map((item) => (
            <NavItem key={item.path} {...item} />
          ))}
        </div>
      </nav>

      {/* Footer */}
      <div style={{ padding: "16px 16px 24px", borderTop: `1px solid ${G.darkBorder}` }}>
        {BOTTOM.map((item) => (
          <NavItem key={item.path} {...item} />
        ))}
      </div>
    </div>
  );
}
